module.exports = __webpack_public_path__ + "static/media/undraw_connected_world_wuay.e19f89bb.svg";